import { Component, OnInit, Input } from '@angular/core';
import { GiveRatingDialogComponent } from '../give-rating-dialog/give-rating-dialog.component';
import { MatDialog } from '@angular/material';
import { BehaviorSubject } from 'rxjs';
import { JobApplication } from 'src/@core/interfaces/job/job-application.model';
import { Dates, Employment } from 'src/@core/interfaces/employment/employment.model';
import { AttendanceService } from 'src/@core/services/job/attendance.service';
import { Search } from 'src/@core/interfaces/search';
import { Attendance } from 'src/@core/interfaces/job/attendance.model';
import { EmploymentHistoryService } from 'src/@core/services/employment/employment-history.service';
import { Employer } from 'src/@core/interfaces/employer/employer.model';
import { DatePipe } from '@angular/common';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { MarkAttendanceDialogComponent } from '../mark-attendance-dialog/mark-attendance-dialog.component';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import moment from 'moment';

@Component({
  selector: 'hour4u-admin-active-job-seeker-card',
  templateUrl: './active-job-seeker-card.component.html',
  styleUrls: ['./active-job-seeker-card.component.scss']
})
export class ActiveJobSeekerCardComponent implements OnInit {

  dataChange: BehaviorSubject<any>;
  @Input('jobApplication') jobApplication: JobApplication;
  @Input('employer') employer: Employer;
  @Input('employment') employmentData: Employment;
  @Input('date') date: Dates;
  showProgress = true;
  params: Search[] = [];
  attendance: Attendance = new Attendance();
  employment: Employment = new Employment();
  jobStatus = 'completed';
  roles = roles;
  entityTypes = entityTypes;
  baseImageUrl = environment.image_url;
  workImages: any[] = [];
  isLoading: boolean = false;
  diameter = 30;
  loaderColor: string;
  mode = 'indeterminate';

  constructor(private dialog: MatDialog,
    private attendanceService: AttendanceService,
    private employmentHistoryServce: EmploymentHistoryService,
    private router: Router,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.getAttendance();
    this.loadHistory();
  }

  async loadHistory() {
    this.isLoading = true;
    this.employment = new Employment();
    this.params = [];
    this.params.push(new Search('employmentId', this.jobApplication.employmentId));
    this.params.push(new Search('jobSeekerId', this.jobApplication.jobSeekerId));
    this.employmentHistoryServce.searchAndSort(0, 1000, null, null, this.params).toPromise()
      .then(data => {
        this.employment.history = data.content;
      }).finally(() => {
        this.employment.sliderImages = [];
        console.log("###@@@@@@@@@@@@@@@@@@@@@@@2", this.employment.history)
        this.employment.history.forEach(history => {
          let historyDate = new Date(history.historyDate[0], history.historyDate[1] - 1, history.historyDate[2]);
          let newDate = new Date(this.date.date[0], this.date.date[1] - 1, this.date.date[2]);

          console.log(historyDate, newDate)
          const date = moment(historyDate).format('MM-DD-YYYY');
          const date2 = moment(newDate).format('MM-DD-YYYY');
          console.log("date", date, date2, date == date2)
          if ((history.imageProofs != null) && history.imageProofs.length) {
            this.employment.sliderImages = [];

            // Filter the data based on proofEnum
            const startEntries = history.imageProofs.filter(entry => entry.proofEnum === "START");
            const middleEntries = history.imageProofs.filter(entry => entry.proofEnum === "MIDDLE");
            const endEntries = history.imageProofs.filter(entry => entry.proofEnum === "END");

            // Concatenate the filtered arrays
            const sortedData = startEntries.concat(middleEntries, endEntries);

            sortedData.forEach((image: any) => {
              if (image.proofEnum == 'START' || image.proofEnum == 'END') {
                this.employment.sliderImages.push({
                  image: this.baseImageUrl + image.imagePath,
                  thumbImage: this.baseImageUrl + image.imagePath,
                  title: image.description + ' | ' + image.proofEnum
                })
              }
              else {
                image.proofOfWorkImages = image.workProofs.filter((ip: any) => ip.fieldType === 'file')
                if (image.proofOfWorkImages && image.proofOfWorkImages.length) {
                  image.proofOfWorkImages.forEach(el => {
                    if (el.fieldValue) {
                      this.employment.sliderImages.push({
                        image: el.fieldValue,
                        thumbImage: el.fieldValue,
                        title: el.fieldLabel + ' Image | ' + image.proofEnum
                      })
                    }
                  });
                } else {
                  if (image.imagePath) {
                    this.employment.sliderImages.push({
                      image: image.imagePath.includes(this.baseImageUrl) ? image.imagePath : this.baseImageUrl + image.imagePath,
                      thumbImage: image.imagePath.includes(this.baseImageUrl) ? image.imagePath : this.baseImageUrl + image.imagePath,
                      title: image.description + ' | ' + image.proofEnum
                    })
                  }
                }
              }
            });
          }

          console.log("####################", this.employment.sliderImages)
          this.workImages = history.imageProofs.filter(ip => ip.proofEnum == 'MIDDLE');
          this.isLoading = false;
        });
      });
  }

  getAttendance() {
    this.isLoading = true;
    this.attendance = new Attendance();
    this.params = [];
    this.params.push(new Search('employmentId', this.jobApplication.employmentId));
    this.params.push(new Search('jobSeekerId', this.jobApplication.jobSeekerId));
    this.attendanceService.searchAndSort(0, 1000, null, null, this.params).subscribe(data => {
      data.content.forEach(a => {
        if (a.checkIn) {
          let checkInDate = a.checkIn[0] + "," + a.checkIn[1] + "," + a.checkIn[2];
          if (checkInDate == this.date.date) {
            this.attendance = a;
            console.log(this.attendance)
          }
        }
      });

      //this.attendance = data.content[0];

      if (!this.attendance) {
        this.showProgress = false;
        // check is job not started
        this.jobStatus = 'notstarted';
      } else {
        // check is job completed
        if (this.attendance.checkOut != null) {
          // show completed green box
          this.jobStatus = 'completed';
          this.showProgress = false;
        } else {
          // in progress
          this.jobStatus = 'inProgress';
        }
      }
      this.isLoading = false;
    }, (err => {
      this.isLoading = false;
    }));
  }

  getProgress(timeFrom, timeTo) {
    if (!timeFrom || !timeTo) return;
    // parse from time
    let from = new Date();

    from.setHours(timeFrom[0]);
    from.setMinutes(timeFrom[1]);

    // parse to time
    let to = new Date();
    to.setHours(timeTo[0]);
    to.setMinutes(timeTo[1]);

    // calculate total job time in minutes
    let totalJobTime = Math.round(((to.getTime() - from.getTime()) / 1000) / 60);

    // calculate time till now in minutes
    let timeSpent = Math.round((((new Date()).getTime() - from.getTime()) / 1000) / 60);

    // calculate percentage
    return Math.round((timeSpent / totalJobTime) * 100);
  }

  openRatingDialog() {
    const dialogRef = this.dialog.open(GiveRatingDialogComponent, {

      width: '700px',
      disableClose: true,
      data: { jobApplication: this.jobApplication, employer: this.employer }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataChange.next(1);
      }
    });
  }

  openAttendance() {

    const dialogRef = this.dialog.open(MarkAttendanceDialogComponent, {
      width: '550px',
      disableClose: true,
      data: { attendance: this.attendance, jobApplication: this.jobApplication, employer: this.employer, employment: this.employmentData, date: this.date }
    });
    dialogRef.afterClosed().subscribe(
      result => {
        if (result != 'Canceled') {
          this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
          this.router.navigated = false;
          this.router.navigate(['/employment/active/' + this.jobApplication.employmentId, {
            date: this.date.date
          }]);
        }
      }
    );
  }


  viewTasksOfEmployment() {
    this.router.navigate(['/employment/active/workproof/' + this.jobApplication.employmentId + '/' + this.jobApplication.jobSeekerId, {
      date: this.date.date,
      view: 'table'
    }]);
  }

}
